export default __webpack_public_path__ + "static/media/badge-small-01.9f1a1ee6.svg";